import React, {useRef} from 'react';
import { Link } from 'react-router-dom';
import AuthService from '../services/AuthService';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import AccessibleLink from './AccessibleLink';
import { isElectionActive } from '../util/electionStatus';

const appLogo = `${process.env.PUBLIC_URL}/logo-new.png`;
const mnsuWebsiteLabel = 'Minnesota State University, Mankato website';

const PageHeader = (props) => {
    let headerRef = useRef(null);
    const isCurrentElectionActive = isElectionActive({
      locked: props.electionData[0] && props.electionData[0].locked,
      activeStatus: props.electionData[0] && props.electionData[0].activeStatus,
    });
    const headerStyle = {
        boxShadow: '0 0 10px rgba(0,0,0,0.5)',
      };
    const ShowButton = () => {
        return (
          <ul className='utility-nav'>
          <li key='approved-candidates'>
            <AccessibleLink
              component={Link}
              className='link-no-border'
              description='Navigates to the public page of approved candidate statements and photos.'
              to={{
                pathname: '/candidates',
              }}
            >
              Approved Candidates
            </AccessibleLink>
          </li>
          {AuthService.isTokenValid() ? (
          <>
          { AuthService.isAdmin() ? (
            <> 
           <li key='home'>
            <AccessibleLink
              component={Link}
              className='link-no-border'
              description='Navigates to the Voting Booth home page.'
              to={{
                pathname: '/',
              }}
            >
              Home
            </AccessibleLink>
          </li>
          <li key='mock'>
            <AccessibleLink
              component={Link}
              className='link-no-border'
              description='Navigates to the mock voter page for election testing.'
              to={{
                pathname: '/mock',
              }}
            >
              Mock Voter
            </AccessibleLink>      
          </li>           <li key='election'>
          <DropdownButton
            bsStyle='utility'
            title='Manage'
            key={0}
            id={`dropdown-basic`}
          >
            <AccessibleLink
              component={MenuItem}
              description='Navigates to the Manage Elections page.'
              eventKey='1'
              href='#/elections'
            >
              Elections
            </AccessibleLink>
            <AccessibleLink
              component={MenuItem}
              description='Navigates to the Manage Candidates page.'
              eventKey='2'
              href='#/candidate'
            >
              Candidates
            </AccessibleLink>
            <AccessibleLink
              component={MenuItem}
              description='Navigates to the Manage Parties page.'
              eventKey='3'
              href='#/party'
            >
              Parties
            </AccessibleLink>
            <AccessibleLink
              component={MenuItem}
              description='Navigates to the Manage Admins page.'
              eventKey='4'
              href='#/admin'
            >
              Admins
            </AccessibleLink>
           
            </DropdownButton>      
          </li>
            {/* <li key='person-name'>
              <Link
                className='link-no-border'
                to={{
                  pathname: '/',
                }}
              >
                Welcome{' '}
                {AuthService.getCurrentUser()
                  ? AuthService.getCurrentUser().data.displayName
                  : ''}
              </Link>
            </li> */}
          </>
        ) : ''}
        { !AuthService.alreadyVoted() && AuthService.isStudent() ? (
        !AuthService.isAdmin() && isCurrentElectionActive ? (
        <li key='vote'>
        <AccessibleLink
          component={Link}
          className='link-no-border'
          description='Navigates to the voting page so you can cast your ballot.'
          to={{
            pathname: '/',
          }}
        >
          Vote!!
        </AccessibleLink>      
      </li>) : (isCurrentElectionActive ? (<li key='vote'>
        <AccessibleLink
          component={Link}
          className='link-no-border'
          description='Navigates to the voting page so you can cast your ballot.'
          to={{
            pathname: '/vote',
          }}
        >
          Vote!!
        </AccessibleLink>      
      </li>) : '')) : ''}
      { AuthService.isCandidate() ? (
        <li key='statement'>
        <AccessibleLink
          component={Link}
          className='link-no-border'
          description='Navigates to the page for managing your candidate statement and photo.'
          to={{
            pathname: '/statement',
          }}
        >
          Statement/Photo
        </AccessibleLink>      
      </li> ): ''}
      <li key='validate'>
        <AccessibleLink
          component={Link}
          className='link-no-border'
          description='Navigates to the vote validation page.'
          to={{
            pathname: '/validate',
          }}
        >
          Validate Vote
        </AccessibleLink>      
      </li>
        <li key='logout'>
          <AccessibleLink
            component={Link}
            className='link-no-border'
            description='Signs you out of the Voting Booth application.'
            to={{
              pathname: '/logout',
            }}
          >
            Logout
          </AccessibleLink>
        </li>
        </>
        ) : null}
        </ul>
        );
      };

    return(
        <header
        id='header'
        style={headerStyle}
        className={
          'l-header header slide-over-transition l-header header slide-over-transition headroom headroom--not-bottom headroom--pinned headroom--top'
        }
        ref={headerRef}
      >
        <div className='l-header-inner'>
          <div className='header-branding'>
            <AccessibleLink
              component='a'
              aria-label={mnsuWebsiteLabel}
              className='header-app-logo'
              description='Navigates to the Minnesota State University, Mankato website.'
              href='https://mankato.mnsu.edu'
            >
              <img
                src={appLogo}
                className='app-logo'
                alt='Minnesota State University, Mankato logo'
              />
            </AccessibleLink>
          </div>
          <ShowButton />
        </div>
      </header>
    );
};


export default PageHeader;
